import React, { FC } from "react";
import { DialogStateReturn } from "reakit/Dialog";

import { IConsultantProfile } from "@/data/consultant-profiles";
import { CreateCompanyDialogModal } from "@/views/Companies/Create";
import { ProfileType } from "@/views/components/ProfileTypePicker";
import { ProfileTypePickerDialogModal } from "@/views/components/ProfileTypePickerDialogModal";
import { AddLocationToProfileModal } from "@/views/consultant-profiles/AddLocationToProfileModal";
import { BlockedProfileModal } from "@/views/consultant-profiles/BlockedProfileModal";
import { CreatePrivatePersonDialogModal } from "@/views/ConsultantProfiles/Create";
import { ProfilesListModal } from "@/views/Onboarding/ProfilesList";

interface IContextDropdownModalsProps {
  currentProfile?: IConsultantProfile;
  blockedProfile?: IConsultantProfile;
  blockedProfileModalState: DialogStateReturn;
  addLocationToProfileModalState: DialogStateReturn;
  previewProfile: any;
  isCreateCompanyModalOpen: any;
  isCreatePrivatePersonModalOpen: boolean;
  isProfileTypePickerModalOpen: boolean;
  handleTypePickerModalClose: () => void;
  handleCreateCompanyModalClose: () => void;
  handleCreatePrivatePersonModalClose: () => void;
  handleConsultantModalClose: () => void;
  handleProfileSelect: (profileType: ProfileType) => void;
}

export const ContextDropdownModals: FC<IContextDropdownModalsProps> = ({
  currentProfile,
  blockedProfile,
  blockedProfileModalState,
  addLocationToProfileModalState,
  previewProfile,
  isCreateCompanyModalOpen,
  isCreatePrivatePersonModalOpen,
  isProfileTypePickerModalOpen,
  handleTypePickerModalClose,
  handleCreateCompanyModalClose,
  handleCreatePrivatePersonModalClose,
  handleConsultantModalClose,
  handleProfileSelect,
}) => {
  return (
    <>
      <CreateCompanyDialogModal open={isCreateCompanyModalOpen} onClose={handleCreateCompanyModalClose} />

      <CreatePrivatePersonDialogModal
        open={isCreatePrivatePersonModalOpen}
        onClose={handleCreatePrivatePersonModalClose}
      />

      <ProfileTypePickerDialogModal
        onProfileSelect={handleProfileSelect}
        open={isProfileTypePickerModalOpen}
        onClose={handleTypePickerModalClose}
      />

      {previewProfile && (
        <ProfilesListModal open={!!previewProfile} onClose={handleConsultantModalClose} payload={previewProfile} />
      )}

      {blockedProfile && <BlockedProfileModal dialogState={blockedProfileModalState} profile={blockedProfile} />}

      {currentProfile && (
        <AddLocationToProfileModal dialogState={addLocationToProfileModalState} profile={currentProfile} />
      )}
    </>
  );
};
